var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 374,
    zoomAndPan: "magnify",
    viewBox: "0 0 280.5 90.749999",
    height: 121,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "ea0b4c6938"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9cc6511ef9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.136719 0 L 279.867188 0 L 279.867188 90.5 L 0.136719 90.5 Z M 0.136719 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "15a07f331c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.136719 0 L 279.867188 0 L 279.867188 90.5 L 0.136719 90.5 Z M 0.136719 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6f62ca8918"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 358.960938 163.246094 C 358.960938 166.578125 358.878906 169.902344 358.71875 173.230469 C 358.554688 176.554688 358.308594 179.875 357.984375 183.1875 C 357.65625 186.5 357.25 189.800781 356.761719 193.09375 C 356.273438 196.386719 355.703125 199.667969 355.054688 202.933594 C 354.402344 206.199219 353.675781 209.445312 352.867188 212.675781 C 352.058594 215.902344 351.167969 219.113281 350.203125 222.296875 C 349.234375 225.484375 348.191406 228.644531 347.070312 231.777344 C 345.949219 234.914062 344.75 238.015625 343.476562 241.09375 C 342.203125 244.167969 340.855469 247.210938 339.429688 250.222656 C 338.007812 253.230469 336.511719 256.203125 334.941406 259.140625 C 333.371094 262.074219 331.734375 264.972656 330.019531 267.828125 C 328.308594 270.683594 326.527344 273.492188 324.679688 276.261719 C 322.828125 279.03125 320.914062 281.75 318.929688 284.425781 C 316.945312 287.097656 314.898438 289.722656 312.789062 292.296875 C 310.675781 294.871094 308.5 297.390625 306.265625 299.855469 C 304.03125 302.324219 301.734375 304.734375 299.382812 307.085938 C 297.027344 309.441406 294.617188 311.738281 292.148438 313.972656 C 289.683594 316.207031 287.164062 318.382812 284.589844 320.492188 C 282.015625 322.605469 279.394531 324.652344 276.71875 326.636719 C 274.042969 328.621094 271.324219 330.535156 268.554688 332.386719 C 265.789062 334.234375 262.976562 336.015625 260.121094 337.726562 C 257.265625 339.4375 254.371094 341.078125 251.433594 342.648438 C 248.496094 344.21875 245.523438 345.714844 242.515625 347.136719 C 239.503906 348.5625 236.460938 349.910156 233.386719 351.183594 C 230.3125 352.457031 227.207031 353.65625 224.070312 354.777344 C 220.9375 355.898438 217.777344 356.941406 214.589844 357.910156 C 211.40625 358.875 208.199219 359.761719 204.96875 360.570312 C 201.738281 361.378906 198.492188 362.109375 195.226562 362.757812 C 191.960938 363.410156 188.683594 363.976562 185.390625 364.464844 C 182.097656 364.953125 178.792969 365.363281 175.480469 365.6875 C 172.167969 366.015625 168.847656 366.257812 165.523438 366.421875 C 162.199219 366.585938 158.871094 366.667969 155.542969 366.667969 C 152.210938 366.667969 148.886719 366.585938 145.558594 366.421875 C 142.234375 366.257812 138.914062 366.015625 135.601562 365.6875 C 132.289062 365.363281 128.988281 364.953125 125.695312 364.464844 C 122.398438 363.976562 119.121094 363.410156 115.855469 362.757812 C 112.589844 362.109375 109.34375 361.378906 106.113281 360.570312 C 102.886719 359.761719 99.675781 358.875 96.492188 357.910156 C 93.304688 356.941406 90.144531 355.898438 87.011719 354.777344 C 83.875 353.65625 80.773438 352.457031 77.695312 351.183594 C 74.621094 349.910156 71.578125 348.5625 68.566406 347.136719 C 65.558594 345.714844 62.585938 344.21875 59.648438 342.648438 C 56.714844 341.078125 53.816406 339.4375 50.960938 337.726562 C 48.105469 336.015625 45.296875 334.234375 42.527344 332.386719 C 39.757812 330.535156 37.039062 328.621094 34.363281 326.636719 C 31.691406 324.652344 29.066406 322.605469 26.492188 320.492188 C 23.917969 318.382812 21.398438 316.207031 18.933594 313.972656 C 16.464844 311.738281 14.054688 309.441406 11.703125 307.085938 C 9.347656 304.734375 7.050781 302.324219 4.816406 299.855469 C 2.582031 297.390625 0.40625 294.871094 -1.703125 292.296875 C -3.816406 289.722656 -5.863281 287.097656 -7.847656 284.425781 C -9.832031 281.75 -11.746094 279.03125 -13.597656 276.261719 C -15.445312 273.492188 -17.226562 270.683594 -18.9375 267.828125 C -20.648438 264.972656 -22.289062 262.074219 -23.859375 259.140625 C -25.429688 256.203125 -26.925781 253.230469 -28.347656 250.222656 C -29.773438 247.210938 -31.121094 244.167969 -32.394531 241.09375 C -33.667969 238.015625 -34.867188 234.914062 -35.988281 231.777344 C -37.109375 228.644531 -38.152344 225.484375 -39.121094 222.296875 C -40.085938 219.113281 -40.972656 215.902344 -41.78125 212.675781 C -42.589844 209.445312 -43.320312 206.199219 -43.96875 202.933594 C -44.621094 199.667969 -45.1875 196.386719 -45.675781 193.09375 C -46.164062 189.800781 -46.574219 186.5 -46.898438 183.1875 C -47.226562 179.875 -47.46875 176.554688 -47.632812 173.230469 C -47.796875 169.902344 -47.878906 166.578125 -47.878906 163.246094 C -47.878906 159.917969 -47.796875 156.589844 -47.632812 153.265625 C -47.46875 149.941406 -47.226562 146.621094 -46.898438 143.308594 C -46.574219 139.996094 -46.164062 136.691406 -45.675781 133.398438 C -45.1875 130.105469 -44.621094 126.828125 -43.96875 123.5625 C -43.320312 120.296875 -42.589844 117.050781 -41.78125 113.820312 C -40.972656 110.589844 -40.085938 107.382812 -39.121094 104.199219 C -38.152344 101.011719 -37.109375 97.851562 -35.988281 94.71875 C -34.867188 91.582031 -33.667969 88.476562 -32.394531 85.402344 C -31.121094 82.328125 -29.773438 79.285156 -28.347656 76.273438 C -26.925781 73.265625 -25.429688 70.292969 -23.859375 67.355469 C -22.289062 64.417969 -20.648438 61.523438 -18.9375 58.667969 C -17.226562 55.8125 -15.445312 53 -13.597656 50.234375 C -11.746094 47.464844 -9.832031 44.742188 -7.847656 42.070312 C -5.863281 39.394531 -3.816406 36.773438 -1.703125 34.199219 C 0.40625 31.625 2.582031 29.105469 4.816406 26.640625 C 7.050781 24.171875 9.347656 21.761719 11.703125 19.40625 C 14.054688 17.054688 16.464844 14.757812 18.933594 12.523438 C 21.398438 10.289062 23.917969 8.113281 26.492188 6 C 29.066406 3.890625 31.691406 1.84375 34.363281 -0.140625 C 37.039062 -2.125 39.757812 -4.039062 42.527344 -5.890625 C 45.296875 -7.738281 48.105469 -9.519531 50.960938 -11.230469 C 53.816406 -12.945312 56.714844 -14.582031 59.648438 -16.152344 C 62.585938 -17.722656 65.558594 -19.21875 68.566406 -20.640625 C 71.578125 -22.066406 74.621094 -23.414062 77.695312 -24.6875 C 80.773438 -25.960938 83.875 -27.160156 87.011719 -28.28125 C 90.144531 -29.402344 93.304688 -30.449219 96.492188 -31.414062 C 99.675781 -32.378906 102.886719 -33.269531 106.113281 -34.078125 C 109.34375 -34.886719 112.589844 -35.613281 115.855469 -36.265625 C 119.121094 -36.914062 122.398438 -37.484375 125.695312 -37.972656 C 128.988281 -38.460938 132.289062 -38.867188 135.601562 -39.195312 C 138.914062 -39.519531 142.234375 -39.765625 145.558594 -39.929688 C 148.886719 -40.089844 152.210938 -40.171875 155.542969 -40.171875 C 158.871094 -40.171875 162.199219 -40.089844 165.523438 -39.929688 C 168.847656 -39.765625 172.167969 -39.519531 175.480469 -39.195312 C 178.792969 -38.867188 182.097656 -38.460938 185.390625 -37.972656 C 188.683594 -37.484375 191.960938 -36.914062 195.226562 -36.265625 C 198.492188 -35.613281 201.738281 -34.886719 204.96875 -34.078125 C 208.199219 -33.269531 211.40625 -32.378906 214.589844 -31.414062 C 217.777344 -30.449219 220.9375 -29.402344 224.070312 -28.28125 C 227.207031 -27.160156 230.3125 -25.960938 233.386719 -24.6875 C 236.460938 -23.414062 239.503906 -22.066406 242.515625 -20.640625 C 245.523438 -19.21875 248.496094 -17.722656 251.433594 -16.152344 C 254.371094 -14.582031 257.265625 -12.945312 260.121094 -11.230469 C 262.976562 -9.519531 265.789062 -7.738281 268.554688 -5.890625 C 271.324219 -4.039062 274.042969 -2.125 276.71875 -0.140625 C 279.394531 1.84375 282.015625 3.890625 284.589844 6 C 287.164062 8.113281 289.683594 10.289062 292.148438 12.523438 C 294.617188 14.757812 297.027344 17.054688 299.382812 19.40625 C 301.734375 21.761719 304.03125 24.171875 306.265625 26.640625 C 308.5 29.105469 310.675781 31.625 312.789062 34.199219 C 314.898438 36.773438 316.945312 39.394531 318.929688 42.070312 C 320.914062 44.742188 322.828125 47.464844 324.679688 50.234375 C 326.527344 53 328.308594 55.8125 330.019531 58.667969 C 331.734375 61.523438 333.371094 64.417969 334.941406 67.355469 C 336.511719 70.292969 338.007812 73.265625 339.429688 76.273438 C 340.855469 79.285156 342.203125 82.328125 343.476562 85.402344 C 344.75 88.476562 345.949219 91.582031 347.070312 94.71875 C 348.191406 97.851562 349.234375 101.011719 350.203125 104.199219 C 351.167969 107.382812 352.058594 110.589844 352.867188 113.820312 C 353.675781 117.050781 354.402344 120.296875 355.054688 123.5625 C 355.703125 126.828125 356.273438 130.105469 356.761719 133.398438 C 357.25 136.691406 357.65625 139.996094 357.984375 143.308594 C 358.308594 146.621094 358.554688 149.941406 358.71875 153.265625 C 358.878906 156.589844 358.960938 159.917969 358.960938 163.246094 Z M 358.960938 163.246094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 281,
    xlinkHref: "data:image/png;base64,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",
    id: "85b30f42c2",
    height: 91,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "3269ff1f32"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ea0b4c6938)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 281,
    xlinkHref: "data:image/png;base64,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",
    height: 91,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(1, 0, 0, 1, -48.147293, -278.03949)",
    gradientUnits: "userSpaceOnUse",
    r: 203.980883,
    cx: 203.980883,
    id: "b7ae8db940",
    cy: 205.262158,
    fx: 203.980883,
    fy: 205.262158
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.312073%, 46.403503%, 20.155334%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.338013%, 46.614075%, 20.46814%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.363953%, 46.82312%, 20.779419%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.389893%, 47.033691%, 21.092224%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.415833%, 47.242737%, 21.405029%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.443298%, 47.453308%, 21.717834%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.469238%, 47.662354%, 22.03064%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.495178%, 47.871399%, 22.341919%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.521118%, 48.08197%, 22.654724%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.547058%, 48.291016%, 22.967529%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.572998%, 48.501587%, 23.280334%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.598938%, 48.710632%, 23.59314%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.626404%, 48.921204%, 23.904419%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.652344%, 49.130249%, 24.217224%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.678284%, 49.34082%, 24.530029%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.704224%, 49.549866%, 24.842834%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.730164%, 49.760437%, 25.15564%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.756104%, 49.969482%, 25.466919%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.782043%, 50.180054%, 25.779724%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.809509%, 50.389099%, 26.092529%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.835449%, 50.59967%, 26.405334%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.861389%, 50.808716%, 26.71814%)",
    offset: 0.0820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.887329%, 51.019287%, 27.029419%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.913269%, 51.228333%, 27.342224%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.939209%, 51.437378%, 27.655029%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.966675%, 51.647949%, 27.967834%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(93.992615%, 51.856995%, 28.28064%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.018555%, 52.067566%, 28.591919%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.044495%, 52.276611%, 28.904724%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.070435%, 52.487183%, 29.217529%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.096375%, 52.696228%, 29.530334%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.122314%, 52.906799%, 29.84314%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.14978%, 53.115845%, 30.154419%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.17572%, 53.326416%, 30.467224%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.20166%, 53.535461%, 30.780029%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.2276%, 53.746033%, 31.092834%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.25354%, 53.955078%, 31.40564%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.27948%, 54.165649%, 31.716919%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.306946%, 54.374695%, 32.029724%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.332886%, 54.585266%, 32.342529%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.358826%, 54.794312%, 32.655334%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.384766%, 55.003357%, 32.96814%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.410706%, 55.213928%, 33.279419%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.436646%, 55.422974%, 33.592224%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.462585%, 55.633545%, 33.905029%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.490051%, 55.84259%, 34.217834%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.515991%, 56.053162%, 34.53064%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.541931%, 56.262207%, 34.841919%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.567871%, 56.472778%, 35.154724%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.593811%, 56.681824%, 35.467529%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.619751%, 56.892395%, 35.780334%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.645691%, 57.10144%, 36.09314%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.673157%, 57.312012%, 36.404419%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.699097%, 57.521057%, 36.717224%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.725037%, 57.731628%, 37.030029%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.750977%, 57.940674%, 37.342834%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.776917%, 58.151245%, 37.65564%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.802856%, 58.360291%, 37.966919%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.830322%, 58.570862%, 38.279724%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.856262%, 58.779907%, 38.592529%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.882202%, 58.988953%, 38.905334%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.908142%, 59.199524%, 39.21814%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.934082%, 59.408569%, 39.529419%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.960022%, 59.619141%, 39.842224%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(94.985962%, 59.828186%, 40.155029%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.013428%, 60.038757%, 40.467834%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.039368%, 60.247803%, 40.78064%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.065308%, 60.458374%, 41.091919%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.091248%, 60.667419%, 41.404724%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.117188%, 60.877991%, 41.717529%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.143127%, 61.087036%, 42.030334%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.170593%, 61.297607%, 42.34314%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.196533%, 61.506653%, 42.654419%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.222473%, 61.717224%, 42.967224%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.248413%, 61.92627%, 43.280029%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.274353%, 62.136841%, 43.592834%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.300293%, 62.345886%, 43.90564%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.326233%, 62.554932%, 44.216919%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.353699%, 62.765503%, 44.529724%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.379639%, 62.974548%, 44.842529%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.405579%, 63.18512%, 45.155334%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.431519%, 63.394165%, 45.46814%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.457458%, 63.604736%, 45.779419%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.483398%, 63.813782%, 46.092224%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.510864%, 64.024353%, 46.405029%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.536804%, 64.233398%, 46.717834%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.562744%, 64.44397%, 47.03064%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.588684%, 64.653015%, 47.341919%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.614624%, 64.863586%, 47.654724%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.640564%, 65.072632%, 47.967529%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.666504%, 65.283203%, 48.280334%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.69397%, 65.492249%, 48.59314%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.71991%, 65.70282%, 48.904419%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.74585%, 65.911865%, 49.217224%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.77179%, 66.122437%, 49.530029%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.797729%, 66.331482%, 49.842834%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.823669%, 66.540527%, 50.15564%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.849609%, 66.751099%, 50.466919%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.877075%, 66.960144%, 50.779724%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.903015%, 67.170715%, 51.092529%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.928955%, 67.379761%, 51.405334%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.954895%, 67.590332%, 51.71814%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(95.980835%, 67.799377%, 52.029419%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.006775%, 68.009949%, 52.342224%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.034241%, 68.218994%, 52.655029%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.060181%, 68.429565%, 52.967834%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.086121%, 68.638611%, 53.28064%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.112061%, 68.849182%, 53.591919%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.138%, 69.058228%, 53.904724%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.16394%, 69.268799%, 54.217529%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.18988%, 69.477844%, 54.530334%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.217346%, 69.688416%, 54.84314%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.243286%, 69.897461%, 55.154419%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.269226%, 70.106506%, 55.467224%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.295166%, 70.317078%, 55.780029%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.321106%, 70.526123%, 56.092834%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.347046%, 70.736694%, 56.40564%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.374512%, 70.94574%, 56.716919%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.400452%, 71.156311%, 57.029724%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.426392%, 71.365356%, 57.342529%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.452332%, 71.575928%, 57.655334%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.478271%, 71.784973%, 57.96814%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.504211%, 71.995544%, 58.279419%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.530151%, 72.20459%, 58.592224%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.557617%, 72.415161%, 58.905029%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.583557%, 72.624207%, 59.217834%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.609497%, 72.834778%, 59.53064%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.635437%, 73.043823%, 59.841919%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.661377%, 73.254395%, 60.154724%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.687317%, 73.46344%, 60.467529%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.714783%, 73.674011%, 60.780334%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.740723%, 73.883057%, 61.09314%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.766663%, 74.092102%, 61.404419%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.792603%, 74.302673%, 61.717224%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.818542%, 74.511719%, 62.030029%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.844482%, 74.72229%, 62.342834%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.870422%, 74.931335%, 62.65564%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.897888%, 75.141907%, 62.966919%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.923828%, 75.350952%, 63.279724%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.949768%, 75.561523%, 63.592529%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(96.975708%, 75.770569%, 63.905334%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.001648%, 75.98114%, 64.21814%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.027588%, 76.190186%, 64.529419%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.053528%, 76.400757%, 64.842224%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.080994%, 76.609802%, 65.155029%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.106934%, 76.820374%, 65.467834%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.132874%, 77.029419%, 65.78064%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.158813%, 77.23999%, 66.091919%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.184753%, 77.449036%, 66.404724%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.210693%, 77.658081%, 66.717529%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.238159%, 77.868652%, 67.030334%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.264099%, 78.077698%, 67.34314%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.290039%, 78.288269%, 67.654419%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.315979%, 78.497314%, 67.967224%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.341919%, 78.707886%, 68.280029%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.367859%, 78.916931%, 68.592834%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.393799%, 79.127502%, 68.90564%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.421265%, 79.336548%, 69.216919%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.447205%, 79.547119%, 69.529724%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.473145%, 79.756165%, 69.842529%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.499084%, 79.966736%, 70.155334%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.525024%, 80.175781%, 70.46814%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.550964%, 80.386353%, 70.779419%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.57843%, 80.595398%, 71.092224%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.60437%, 80.805969%, 71.405029%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.63031%, 81.015015%, 71.717834%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.65625%, 81.22406%, 72.03064%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.68219%, 81.434631%, 72.341919%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.70813%, 81.643677%, 72.654724%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.73407%, 81.854248%, 72.967529%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.761536%, 82.063293%, 73.280334%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.787476%, 82.273865%, 73.59314%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.813416%, 82.48291%, 73.904419%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.839355%, 82.693481%, 74.217224%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.865295%, 82.902527%, 74.530029%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.891235%, 83.113098%, 74.842834%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.917175%, 83.322144%, 75.15564%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.944641%, 83.532715%, 75.466919%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.970581%, 83.74176%, 75.779724%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(97.996521%, 83.952332%, 76.092529%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.022461%, 84.161377%, 76.405334%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.048401%, 84.371948%, 76.71814%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.074341%, 84.580994%, 77.029419%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.101807%, 84.791565%, 77.342224%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.127747%, 85.00061%, 77.655029%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.153687%, 85.209656%, 77.967834%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.179626%, 85.420227%, 78.28064%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.205566%, 85.629272%, 78.591919%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.231506%, 85.839844%, 78.904724%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.257446%, 86.048889%, 79.217529%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.284912%, 86.25946%, 79.530334%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.310852%, 86.468506%, 79.84314%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.336792%, 86.679077%, 80.154419%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.362732%, 86.888123%, 80.467224%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.388672%, 87.098694%, 80.780029%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.414612%, 87.307739%, 81.092834%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.442078%, 87.518311%, 81.40564%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.468018%, 87.727356%, 81.716919%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.493958%, 87.937927%, 82.029724%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.519897%, 88.146973%, 82.342529%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.545837%, 88.357544%, 82.655334%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.571777%, 88.566589%, 82.96814%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.597717%, 88.775635%, 83.279419%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.625183%, 88.986206%, 83.592224%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.651123%, 89.195251%, 83.905029%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.677063%, 89.405823%, 84.217834%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.703003%, 89.614868%, 84.53064%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.728943%, 89.825439%, 84.841919%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.754883%, 90.034485%, 85.154724%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.782349%, 90.245056%, 85.467529%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.808289%, 90.454102%, 85.780334%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.834229%, 90.664673%, 86.09314%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.860168%, 90.873718%, 86.404419%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.886108%, 91.08429%, 86.717224%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.912048%, 91.293335%, 87.030029%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.937988%, 91.503906%, 87.342834%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.965454%, 91.712952%, 87.65564%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(98.991394%, 91.923523%, 87.966919%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.017334%, 92.132568%, 88.279724%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.043274%, 92.34314%, 88.592529%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.069214%, 92.552185%, 88.905334%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.095154%, 92.76123%, 89.21814%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.121094%, 92.971802%, 89.529419%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.14856%, 93.180847%, 89.842224%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.1745%, 93.391418%, 90.155029%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.200439%, 93.600464%, 90.467834%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.226379%, 93.811035%, 90.78064%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.252319%, 94.020081%, 91.091919%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.278259%, 94.230652%, 91.404724%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.305725%, 94.439697%, 91.717529%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.331665%, 94.650269%, 92.030334%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.357605%, 94.859314%, 92.34314%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.383545%, 95.069885%, 92.654419%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.409485%, 95.278931%, 92.967224%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.435425%, 95.489502%, 93.280029%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.461365%, 95.698547%, 93.592834%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.488831%, 95.909119%, 93.90564%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.514771%, 96.118164%, 94.216919%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.54071%, 96.327209%, 94.529724%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.56665%, 96.537781%, 94.842529%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.59259%, 96.746826%, 95.155334%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.61853%, 96.957397%, 95.46814%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.645996%, 97.166443%, 95.779419%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.671936%, 97.377014%, 96.092224%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.697876%, 97.58606%, 96.405029%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.723816%, 97.796631%, 96.717834%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.749756%, 98.005676%, 97.03064%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.775696%, 98.216248%, 97.341919%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.801636%, 98.425293%, 97.654724%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.829102%, 98.635864%, 97.967529%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.855042%, 98.84491%, 98.280334%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.880981%, 99.055481%, 98.59314%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.906921%, 99.264526%, 98.904419%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.932861%, 99.475098%, 99.217224%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.958801%, 99.684143%, 99.530029%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(99.986267%, 99.894714%, 99.842834%)",
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(100%, 100%, 100%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "544af0b603"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 281,
    y: 0,
    height: 91
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "9eb0bd671f",
    patternUnits: "userSpaceOnUse",
    width: 281,
    patternTransform: "matrix(0.997253, 0, 0, -0.997253, 0.135991, 90.670219)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 281 91",
    height: 91,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#544af0b603)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#3269ff1f32)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -62.016366,
    fill: "url(#b7ae8db940)",
    width: 405.032732,
    height: 131.04,
    y: -20.1
  }))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9cc6511ef9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.136719 0 L 279.867188 0 L 279.867188 90.5 L 0.136719 90.5 Z M 0.136719 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.136719 0 L 279.867188 0 L 279.867188 90.5 L 0.136719 90.5 Z M 0.136719 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#15a07f331c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6f62ca8918)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#9eb0bd671f)",
    d: "M 0.136719 0 L 279.867188 0 L 279.867188 90.5 L 0.136719 90.5 Z M 0.136719 0 ",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondo);
export default __webpack_public_path__ + "static/media/fondo.d1a6c7530d8a740c86cf6f30a9a255db.svg";
export { ForwardRef as ReactComponent };